import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { Escalation } from '../models/escalations.model';
import { Paginated } from '../../shared/models/paginated.model';

@Injectable({
    providedIn: 'root'
})
export class EscalationService {
    private httpClient = inject(HttpClient);

    public getEscalations(page?: number | null): Observable<Paginated<Escalation>> {
        return this.httpClient
            .get<
                Paginated<Escalation>
            >(`${environment.apiUrl}/me/escalations?pageSize=10${page ? `&page=${page}` : ''}`)
            .pipe(catchError((error: Error) => throwError(() => new Error(error.message))));
    }

    public snoozeEscalation(id: string): Observable<void> {
        return this.httpClient
            .post<void>(`${environment.apiUrl}/me/escalations/${id}/snooze`, {})
            .pipe(catchError((error: Error) => throwError(() => new Error(error.message))));
    }
}
